<template>
  <div class="stepper">
    <ul>
      <li v-for="(step, index) in steps" class="step" @click="$emit('stepClick', {step, index})" :class="{active: activeIndex === index}">
        <div class="step__number">{{index + 1}}</div>
        <div class="step__name">{{step.name}}</div>
        <IconArrowRight/>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
  .stepper {

    ul{
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 20px;
    }

    .step {
      display: flex;
      align-items: center;
      gap: 20px;

      @media (max-width: 900px) {
        gap: 10px;
      }


      svg{
        width: 100%;
        height: auto;
        max-width: 75px;
      }

      &:last-child{
        svg{
          display: none;
        }
      }

      &__number{
        border: 2px solid #8c8c8c;
        border-radius: 50%;
        color: #8c8c8c;
        width: 40px;
        min-width: 40px;
        height: 40px;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      &__name{
        color: #8c8c8c;
        font-size: 14px;
        font-weight: 600;
        @media (max-width: 900px) {
          font-size: 12px;
        }

      }

      &.active{

        .step__number{
          border: 2px solid var(--attendee-brand-color);
          color: var(--attendee-brand-color);
        }

        .step__name{
          color: var(--attendee-brand-color);

        }
      }
    }
  }
</style>

<script>
import IconArrowRight from "../icons/IconArrowRight";
export default {
  components: {IconArrowRight},
  props: ['steps', 'activeIndex']
}
</script>